import { useAnalytics } from '@medely/ui-kit';
import { useCurrentUser } from '../useCurrentUser';

export const useW2interestEvent = () => {
  const analytics = useAnalytics();
  const { currentUser } = useCurrentUser();

  const trackW2InterestDialogView = () => {
    analytics.track({
      context: 'W2 Interest',
      subcontext: null,
      action: 'Viewed',
      account_id: currentUser?.id,
    });
  };

  const trackW2InterestCardClick = () => {
    analytics.track({
      context: 'W2 Interest',
      subcontext: 'Save Button',
      action: 'Clicked',
      account_id: currentUser?.id,
    });
  };

  const trackW2InterestBannerClick = () => {
    analytics.track({
      context: 'Product Application Markets',
      subcontext: 'W2 Interest Link',
      action: 'Clicked',
      account_id: currentUser?.id,
    });
  };

  return {
    trackW2InterestDialogView,
    trackW2InterestCardClick,
    trackW2InterestBannerClick,
  };
};
